/**
 * The merchant workspace layout route and the feature routes it composes.
 *
 * One shell instance for the whole workspace: every merchant page renders
 * into the shell's outlet so the sidebar never remounts around it. Feature
 * route fragments are composed here in the same order they had in App.tsx;
 * paths are the public contract and stay unchanged.
 */

import { Route } from 'react-router-dom';

import { businessProfileRoutes } from '../business-profile/routes.js';
import { merchantIntakeShellRoutes } from '../merchant-intake/routes.js';
import { productionLinesRoutes } from '../production-lines/routes.js';
import { recommendationsRoutes } from '../recommendations/routes.js';
import { settingsRoutes } from '../settings/routes.js';
import { tasteCalibrationRoutes } from '../taste-calibration/routes.js';
import { videosRoutes } from '../videos/routes.js';
import { RequireMerchant } from './guards.js';
import { MerchantHomePage } from './MerchantHomePage.js';
import { MerchantWorkspaceShell } from './MerchantWorkspaceShell.js';

export function merchantShellRoutes() {
  return (
    <Route
      element={
        <RequireMerchant>
          <MerchantWorkspaceShell />
        </RequireMerchant>
      }
    >
      <Route path="/home" element={<MerchantHomePage />} />
      {productionLinesRoutes.index()}
      {merchantIntakeShellRoutes()}
      {tasteCalibrationRoutes()}
      {recommendationsRoutes()}
      {productionLinesRoutes.detail()}
      {videosRoutes()}
      {businessProfileRoutes()}
      {settingsRoutes()}
    </Route>
  );
}
